import { set } from 'lodash'
import { Controller } from 'stimulus'

export default class extends Controller {

  animateIntro() {
    setTimeout(() => {
      const windowScroll = window.pageYOffset

      if (!(windowScroll > 100)) {
        this.element.classList.add('-animate')
      }
    }, 3000)
  }
}
